// extracted by mini-css-extract-plugin
export default {"root":"style_root__4mxNp","logo":"style_logo__01GgF","description":"style_description__-wXPf"};